import { CubeReflectionMapping, CubeRefractionMapping, CubeUVReflectionMapping, EquirectangularReflectionMapping, EquirectangularRefractionMapping, UVMapping } from 'three';

export const mappingValues = {
    UVMapping,
    CubeReflectionMapping,
    CubeRefractionMapping,
    EquirectangularReflectionMapping,
    EquirectangularRefractionMapping,
    CubeUVReflectionMapping,
};

export const mappingNames: { [v: number]: Mapping } = {};
Object.keys(mappingValues).forEach((k: Mapping) =>
{
    mappingNames[mappingValues[k]] = k;
});

export type Mapping = keyof typeof mappingValues;
